// extracted by mini-css-extract-plugin
export var activeFilterButton = "_nu-c";
export var backButton = "_nu-4";
export var backIcon = "_nu-5";
export var chevronShortcut = "_nu-6";
export var container = "_nu-1";
export var editor = "_nu-8";
export var editorWrapper = "_nu-7";
export var prefix = "_nu-2";
export var searchIcon = "_nu-3";
export var suffix = "_nu-9";
export var suffixContent = "_nu-a";
export var suffixText = "_nu-b";
export var wrapper = "_nu-0";